import {buildArray} from 'shared/web';

import i18n from '../../../../../i18n/i18n';
import {ChartEncodingLegendItem} from '../types/ChartEncodingLegendItem';
import {ChartToolbarHighlights} from '../types/ChartToolbarHighlight';

interface GetChartEncodingLegendItemsParams {
  highlights: ChartToolbarHighlights;
  selectedSellerId: string | null;
  isSellerTypeEnabled: boolean;
  isSuspiciousFlagEnabled: boolean;
}

export function getChartEncodingLegendItems(
  params: GetChartEncodingLegendItemsParams
): ChartEncodingLegendItem[] {
  return buildArray<ChartEncodingLegendItem>([
    {
      id: 'default',
      label: i18n.t('entity.statisticsChart.legend.defaultDot'),
      icon: 'circle',
    },
  ])
    .when(params.isSellerTypeEnabled && params.highlights.sellerType, {
      id: 'privateSeller',
      label: i18n.t('entity.statisticsChart.toolbar.privateSeller'),
      icon: 'doughnut',
    })
    .when(
      params.highlights.repriced,
      {
        id: 'repriced-increased',
        label: i18n.t('entity.statisticsChart.legend.priceIncreased'),
        icon: 'triangle-increased',
      },
      {
        id: 'repriced-decreased',
        label: i18n.t('entity.statisticsChart.legend.priceDecreased'),
        icon: 'triangle-decreased',
      }
    )
    .when(params.selectedSellerId !== null, {
      id: 'border-dealer',
      label: i18n.t('entity.statisticsChart.toolbar.dealer'),
      icon: 'border-dealer',
    })
    .when(params.isSuspiciousFlagEnabled && params.highlights.suspicious, {
      id: 'border-suspicious',
      label: i18n.t('page.advertisiments.suspicious'),
      icon: 'border-suspicious',
    })
    .when(params.highlights.new, {
      id: 'border-new',
      label: i18n.t('entity.statisticsChart.toolbar.new'),
      icon: 'border-new',
    });
}
